import React, { useState, useEffect, Fragment } from 'react'
import { useNavigate } from 'react-router-dom';
import ServicesServices from '../../../../Api/AdBazar/Services/ServicesServices';
import { Box, CardMedia, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material';
import BreadCrumbs from '../../../../Components/BreadCrumbs/BreadCrumbs';
import Colors from '../../../../Assets/Styles/Colors';
import { DeleteForever, Edit, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { SecondaryButton } from '../../../../Components/Buttons/index';
import FormDialog from '../../../../Components/Dialogs/FormDialog';
import UFormDialog from '../../../../Components/Dialogs/UFormDialog';
import ConfirmationDialog from '../../../../Components/Dialogs/ConfirmationDialog';
import { baseUrl } from '../../../../../axios';
import { SuccessToaster } from '../../../../Components/Toaster/Toaster';
import moment from 'moment';

const tableHead = ["Service Name", "Created At", "Status", "Actions"];

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
    </Box>
  );
}

function Services() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [name, setName] = useState("")
  const [services, setServices] = useState([]);
  const [open, setOpen] = useState(false);
  const [uOpen, setUOpen] = useState(false);
  const [data, setData] = useState({});
  const [cOpen, setCOpen] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(null);

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickUOpen = (data) => {
    setUOpen(true);
    setData(data);
  };

  const handleUClose = () => {
    setUOpen(false);
  };

  const handleClickCOpen = (id) => {
    setCOpen(true);
    setId(id);
  };

  const handleCClose = () => {
    setCOpen(false);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllServices(newPage + 1, rowsPerPage)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getAllServices(page, event.target.value);
  };

  const getAllServices = async (page, limit) => {
    try {
      let result = await ServicesServices.getAllServices(
        page ? page : 1,
        limit ? limit : 10
      );
      console.log("🚀 ~ getAllServices ~ result:", result)
      // const filtered = result?.data?.service?.filter((item) => item.isActive == true);
      setServices(result?.data?.service);
      setCount(result?.data?.totalServices);
      // console.log(filtered);
    } catch (error) {
      console.log(error);
    }
  }

  const submitService = async (formData) => {
    const obj = {
      name: formData.name,
    }
    try {
      const result = await ServicesServices.createService(obj);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message);
      }
    } catch (error) {
      console.log(error)
    } finally {
      handleClose();
      setName("");
    }
  }

  const updateService = async (formData) => {
    const obj = {
      name: formData.name,
      isActive: status
    }
    try {
      const result = await ServicesServices.updateService(data?._id, obj);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message)
      }
    } catch (error) {
      console.log(error)
    } finally {
      handleUClose();
    }
  }

  const deleteService = async () => {
    try {
      const result = await ServicesServices.deleteService(id);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleCClose();
      getAllServices();
    }
  }

  useEffect(() => {
    getAllServices();
  }, [open, uOpen]);

  return (
    <Fragment>
      <FormDialog
        open={open}
        handleClose={handleClose}
        title={"Create Service"}
        label={"Service Name"}
        action={submitService}
        name={name}
        setName={setName}
      />

      <UFormDialog
        open={uOpen}
        handleClose={handleUClose}
        title={"Update Service"}
        label={"Service Name"}
        data={data}
        action={updateService}
        status={status}
        setStatus={setStatus}
      />

      <ConfirmationDialog
        open={cOpen}
        onClose={handleCClose}
        action={deleteService}
        id={id}
        title={"Delete Service"}
        btn={"Delete"}
      />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Services
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Services"]} />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            bgcolor: Colors.white,
            p: 2,
            borderRadius: "12px",
            textAlign: "right",
            mt: 2,
          }}
        >
          <SecondaryButton
            // disabled={role !== "A" ? true : false}
            title="Create Service"
            onClick={() => handleClickOpen()}
          />
        </Box>
        <Box>
          <TableContainer
            component={Paper}
            sx={{
              "&::-webkit-scrollbar": {
                bgcolor: Colors.white,
                height: "8px",
                borderRadius: "10px",
                cursor: "pointer",
              },
              "&::-webkit-scrollbar-thumb": {
                bgcolor: Colors.primary,
                borderRadius: "10px",
                cursor: "pointer",
              },
              "&.MuiPaper-root": {
                borderRadius: "12px",
                mt: 2,
                boxShadow: 0,
              },
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ bgcolor: Colors.lightGray }}>
                  {tableHead.map((item, index) => (
                    <TableCell key={index}>
                      <Typography sx={{ fontWeight: "bold", textAlign: item == "Actions" && "end" }}>
                        {item}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {services.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row?.name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {moment(row?.createdAt).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Chip
                        label={row?.isActive ? 'Active' : 'In Active'}
                        sx={{
                          bgcolor: row?.isActive ? Colors.success + 26 : Colors.danger + 26,
                          color: row?.isActive ? Colors.success : Colors.danger,
                          height: 26,
                          textTransform: 'capitalize',
                        }}
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Box display="flex" justifyContent={"flex-end"}>
                        <Tooltip title="View">
                          <IconButton
                            onClick={() => {
                              handleClickUOpen(row)
                            }}
                          >
                            <Edit sx={{ color: Colors.success }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            onClick={() => {
                              handleClickCOpen(row._id)
                            }}
                          >
                            <DeleteForever sx={{ color: Colors.primary }} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Table sx={{ marginTop: "12px" }}>
            <TablePagination
              sx={{
                borderBottom: "none",
                bgcolor: Colors.white,
                borderRadius: "12px",
              }}
              rowsPerPageOptions={[10, 20, 30]}
              colSpan={12}
              count={+count}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Table>
        </Box>
      </Box>
    </Fragment >
  )
}

export default Services